export class PaymentOptions {
    paymentTypeId: number;
    paymentName: string;
    paymentCharge: number;
    paymentDueDate: Date;
}
